import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';

const { Icon, Paragraph, Tag } = designSystem;

const defaultCaptions = {};

function PageManagerTemplateItem({ item, captions = defaultCaptions, onItemClick }) {
  // We render controls only when we hover item
  // 'cause if we render all of the controls for
  // all items then browser will run out of memory
  // 'cause of plenty `<svg>` tags on the page.
  // (case with a lot of created pages)
  const [isHovered, setHoverState] = useState(false);

  const onItemClickHandler = useCallback(() => {
    onItemClick(item);
  }, [onItemClick, item]);

  if (!item) return null;

  const className = classNames('ws-page-manager__item');

  return (
    <div
      className={className}
      onClick={onItemClickHandler}
      onMouseEnter={() => setHoverState(true)}
      onMouseLeave={() => setHoverState(false)}
    >
      <span className="ws-page-manager__item-logo">
        <Icon glyph="page" size={20} />
      </span>
      <Paragraph isClipped>
        <span translate="no">{item.name}</span>
      </Paragraph>
      <div className="ws-page-manager__item-controls">
        {isHovered ? (
          <div className="ws-page-manager__template-control">
            <Tag
              appearance="accent-secondary"
              size="large"
              iconGlyph="ai"
              iconStrokeWidth={1.5}
              label={captions.hoveredControl}
            />
          </div>
        ) : (
          <Icon glyph="ai" size={20} strokeWidth={1.5} type="accent" />
        )}
      </div>
    </div>
  );
}

PageManagerTemplateItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  captions: PropTypes.shape({
    hoveredControl: PropTypes.string,
  }),
  onItemClick: PropTypes.func.isRequired,
};

export default PageManagerTemplateItem;
